import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { MethodType } from '@michelin/central-provider/dist/helpers/createAPICall';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import GLOBAL_CONFIG from 'global-variables';

const baseURL = GLOBAL_CONFIG.externalAPIUrl;
const CURRENT_WALKTHROUGH_VERSION = GLOBAL_CONFIG.currentWalkthroughVersion;

const WALKTHROUGH_STATUS_QUERY_KEY = ['walkthrough-status'];

const getWalkthroughStatus = async (): Promise<string | null> => {
  const apiType: MaestroAPI = {
    method: MethodType.GET,
    endpoint: 'cp-be/walkthrough-status',
    baseURL: baseURL || '',
  };
  const response = await maestroApiCall<string>(apiType);

  return response;
};

export function useGetWalkthroughStatus() {
  return useQuery(WALKTHROUGH_STATUS_QUERY_KEY, getWalkthroughStatus);
}

const updateWalkthroughStatus = async (): Promise<string | null> => {
  const apiType: MaestroAPI = {
    method: MethodType.PUT,
    endpoint: 'cp-be/walkthrough-status',
    baseURL: baseURL || '',
  };
  const response = await maestroApiCall<string>(apiType, {
    last_walkthrough_version_seen: CURRENT_WALKTHROUGH_VERSION,
  });

  return response;
};

export function useUpdateWalkthroughStatus() {
  const queryClient = useQueryClient();
  return useMutation(updateWalkthroughStatus, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(WALKTHROUGH_STATUS_QUERY_KEY);
    },
  });
}
 